"use client";

import { usePathname } from "next/navigation";
import { useEffect, useRef } from "react";
import styles from "./PageTransition.module.css";

// Entrada de cada página: el contenido aparece con un fundido corto mientras la cámara
// termina de llegar. También cubre atrás/adelante del navegador, donde no hay salida.
export function PageTransition({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const first = useRef(true);

  useEffect(() => {
    const root = document.documentElement;
    if (first.current) {
      first.current = false;
      return;
    }
    root.dataset.transition = "entering";
    const id = window.setTimeout(() => {
      delete root.dataset.transition;
    }, 700);
    return () => window.clearTimeout(id);
  }, [pathname]);

  return (
    <main id="contenido" className={styles.main} tabIndex={-1}>
      {children}
    </main>
  );
}
